import '../styles/LogoComponent.css';
import compass from '../assets/connexis-logo.svg';

const Logo = () => {
  return (
    <span className="logo-container">
      <span className="logo-text">CONNEXIS</span>
      <img src={compass} alt="Compass" className="logo-icon" />
    </span>
  );
};

export default Logo;
